import React from "react";
import SiteShell from "../components/site/SiteShell";
import { Container, SectionHead, Button } from "../components/site/ui";
import { Reveal } from "../components/site/Reveal";
import { FinalCTA } from "./HomeNew";
import { INDUSTRIES } from "../data/site";

export default function IndustriesPage() {
  return (
    <SiteShell title="Industries — GoBuildWeb" description="GoBuildWeb builds websites and digital systems for home services, contractors, auto, restaurants, retail, e-commerce, professional services, health & wellness and local businesses.">
      <section className="pt-[72px]">
        <Container className="py-16 text-center md:py-24">
          <Reveal>
            <SectionHead center eyebrow="Who we build for" title="Websites tailored to your industry" sub="We understand what customers in your industry look for — and build to convert them." />
          </Reveal>
        </Container>
      </section>

      <section className="pb-16 md:pb-24">
        <Container>
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {INDUSTRIES.map((ind, i) => (
              <Reveal key={ind.id} delay={(i % 3) * 0.06}>
                <div className="group h-full overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03]" data-testid={`industry-${ind.id}`}>
                  <div className="relative aspect-[16/10] overflow-hidden">
                    <img src={ind.img} alt={ind.name} loading="lazy" className="h-full w-full object-cover transition duration-500 group-hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
                    <div className="absolute left-4 top-4 grid h-10 w-10 place-items-center rounded-lg bg-black/60 text-gold-400 ring-1 ring-white/10"><ind.icon size={18} /></div>
                  </div>
                  <div className="p-6">
                    <h3 className="font-display text-xl font-bold text-white">{ind.name}</h3>
                    <p className="mt-2 text-sm text-zinc-400">{ind.blurb}</p>
                    <Button to="/get-started" variant="ghost" className="mt-4 px-0">Build my {ind.name.toLowerCase()} site</Button>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </Container>
      </section>
      <FinalCTA />
    </SiteShell>
  );
}
